import React from 'react';
import { Link } from 'react-router-dom';
import { useModuleSettings } from '../../../contexts/ModuleSettingsContext';

const ConfiguracionProduccionIndex = () => {
  const {
    concesionariaVentaOperacionesEnabled,
    produccionConcesionariaEnabled,
    produccionConcesionariaPlaneamientoEnabled,
    concesionariaOperacionesAlmacenEnabled,
    concesionariaRecetasEnabled,
  } = useModuleSettings();

  const configModuloCompleto =
    produccionConcesionariaEnabled &&
    (!concesionariaVentaOperacionesEnabled ||
      produccionConcesionariaPlaneamientoEnabled ||
      concesionariaOperacionesAlmacenEnabled ||
      concesionariaRecetasEnabled);

  const links = [
    ...(concesionariaVentaOperacionesEnabled
      ? [
          {
            to: '/produccion-concesionaria/configuraciones/area-despacho',
            icon: '📤',
            title: 'Área de despacho',
            desc: 'Destinos por punto de venta y cliente OSV.',
          },
          {
            to: '/produccion-concesionaria/configuraciones/cuadro-venta',
            icon: '📊',
            title: 'Cuadro venta (plantillas)',
            desc: 'Plantillas de columnas del cuadro por POS.',
          },
        ]
      : []),
    ...(configModuloCompleto
      ? [
          {
            to: '/produccion-concesionaria/configuraciones/almacenes-producto-terminado',
            icon: '🏭',
            title: 'Almacenes PT',
            desc: 'Crear almacenes de producto terminado por almacén principal.',
          },
          {
            to: '/produccion-concesionaria/configuraciones/tiempos',
            icon: '🕐',
            title: 'Tiempos',
            desc: 'Desayuno, almuerzo, cena (activo / inactivo).',
          },
          {
            to: '/produccion-concesionaria/configuraciones/tipo-plato',
            icon: '🍽️',
            title: 'Tipo de plato',
            desc: 'Bebida, segundo, guarnición, postre…',
          },
          ...(!concesionariaVentaOperacionesEnabled
            ? [
                {
                  to: '/produccion-concesionaria/configuraciones/area-despacho',
                  icon: '📤',
                  title: 'Área de despacho',
                  desc: 'Áreas de expedición.',
                },
              ]
            : []),
        ]
      : []),
  ];

  return (
    <div className="p-6 max-w-5xl">
      <nav className="text-sm text-gray-600 mb-4">
        <Link to="/dashboard" className="hover:text-teal-600">
          Dashboard
        </Link>
        <span className="mx-2">/</span>
        <Link to="/produccion-concesionaria" className="hover:text-teal-600">
          Producción concesionaria
        </Link>
        <span className="mx-2">/</span>
        <span className="text-gray-800">Configuración</span>
      </nav>

      <h1 className="text-2xl font-semibold text-gray-800">Configuración</h1>
      <p className="mt-1 text-sm text-gray-500">
        {concesionariaVentaOperacionesEnabled && !configModuloCompleto
          ? 'Opciones del cuadro de venta y despacho por punto de venta.'
          : 'Parámetros del módulo de producción concesionaria.'}
      </p>

      <div className="mt-6 grid gap-3 sm:grid-cols-2">
        {links.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="block rounded-lg border border-gray-200 bg-white p-4 shadow-sm hover:border-teal-300 hover:bg-teal-50/50 transition-colors"
          >
            <span className="text-lg">{item.icon}</span>
            <h2 className="mt-2 font-semibold text-gray-900">{item.title}</h2>
            <p className="mt-1 text-sm text-gray-500">{item.desc}</p>
          </Link>
        ))}
      </div>

      {concesionariaVentaOperacionesEnabled && (
        <p className="mt-8 text-sm text-gray-500">
          Operación diaria:{' '}
          <Link
            to="/produccion-concesionaria/operaciones/produccion-dia"
            className="text-teal-700 hover:text-teal-900 font-medium"
          >
            Venta producción
          </Link>
        </p>
      )}
    </div>
  );
};

export default ConfiguracionProduccionIndex;
